export const TRACKING_ID = "UA-225881406-1";
export const PORTAL_DATA = "files/PortalData.csv";
export const PLAYER_DATA = "files/PlayerData.csv";
